export const rotatePoint = (origin, coord, rad) => {
  const rcos = Math.cos(rad)
  const rsin = Math.sin(rad)
  return {
    x: (coord.x - origin.x) * rcos - (coord.y - origin.y) * rsin + origin.x,
    y: (coord.x - origin.x) * rsin + (coord.y - origin.y) * rcos + origin.y
  }
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/rotatePoint.js